/* ============================================================
   BIRDIE — theme JS
   Shopify AJAX cart, predictive search, PDP variants, overlays
============================================================ */
(function () {
  "use strict";

  const money = (cents) =>
    (window.Shopify && window.Shopify.formatMoney)
      ? window.Shopify.formatMoney(cents, window.BIRDIE.moneyFormat)
      : "₹" + Math.round(cents / 100).toLocaleString("en-IN");

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------------- toast ---------------- */
  let toastTimer;
  function toast(msg) {
    const t = $("#toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("on"), 2200);
  }
  window.birdieToast = toast;

  /* ---------------- overlays ---------------- */
  const scrim = () => $("#scrim");
  const drawer = () => $("#cartDrawer");
  const searchOv = () => $("#searchOv");
  const navDrawer = () => $("#navDrawer");

  function openCart() {
    closeSearch();
    navDrawer() && navDrawer().classList.remove("on");
    drawer() && drawer().classList.add("on");
    scrim() && scrim().classList.add("on");
    document.body.classList.add("locked");
  }
  function openNav() {
    closeSearch();
    drawer() && drawer().classList.remove("on");
    navDrawer() && navDrawer().classList.add("on");
    scrim() && scrim().classList.add("on");
    document.body.classList.add("locked");
  }
  function openSearch() {
    drawer() && drawer().classList.remove("on");
    scrim() && scrim().classList.remove("on");
    searchOv() && searchOv().classList.add("on");
    document.body.classList.add("locked");
    setTimeout(() => { const i = $("#searchInput"); i && i.focus(); }, 350);
  }
  function closeSearch() { searchOv() && searchOv().classList.remove("on"); }
  function closeAll() {
    drawer() && drawer().classList.remove("on");
    navDrawer() && navDrawer().classList.remove("on");
    scrim() && scrim().classList.remove("on");
    closeSearch();
    document.body.classList.remove("locked");
  }
  window.birdieOpenCart = openCart;
  window.birdieOpenSearch = openSearch;
  window.birdieOpenNav = openNav;
  window.birdieCloseAll = closeAll;

  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeAll(); });
  document.addEventListener("click", (e) => {
    const t = e.target.closest("[data-cart-open],[data-search-open],[data-nav-open],[data-close]");
    if (!t) return;
    if (t.hasAttribute("data-cart-open")) { e.preventDefault(); openCart(); fetchCart(); }
    else if (t.hasAttribute("data-search-open")) { e.preventDefault(); openSearch(); }
    else if (t.hasAttribute("data-nav-open")) { e.preventDefault(); openNav(); }
    else if (t.hasAttribute("data-close")) { e.preventDefault(); closeAll(); }
  });

  /* ---------------- cart ---------------- */
  const FREE_SHIP = window.BIRDIE ? window.BIRDIE.freeShipThreshold : 199900;

  function setCartCount(n) {
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = n;
      el.toggleAttribute("hidden", n === 0);
    });
    const dc = $("#drawerCount");
    if (dc) dc.textContent = n ? "(" + n + ")" : "";
  }

  function renderCart(cart) {
    const body = $("#cartBody");
    const foot = $("#cartFoot");
    if (!body) return;
    setCartCount(cart.item_count);

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="cart-empty">' +
        '<div class="big">Your cart is empty.</div>' +
        '<span class="micro">Batch is live — and limited</span>' +
        '<a class="micro" style="color:var(--rose)" href="' + window.BIRDIE.routes.allProducts + '">Browse the index →</a>' +
        "</div>";
      if (foot) foot.style.display = "none";
    } else {
      body.innerHTML = cart.items.map((l, i) => {
        const variantTxt = l.options_with_values
          ? l.options_with_values.map((o) => o.value).join(" · ")
          : (l.variant_title || "");
        const img = l.image
          ? l.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2")
          : "";
        return (
          '<div class="cline" data-key="' + l.key + '">' +
            '<img src="' + img + '" alt="' + escapeHtml(l.product_title) + '">' +
            "<div>" +
              "<h4>" + escapeHtml(l.product_title) + "</h4>" +
              '<div class="var">' + escapeHtml(variantTxt) + "</div>" +
              '<div class="lqty">' +
                '<button data-line-dec="' + (i + 1) + '" aria-label="Decrease">−</button>' +
                "<span>" + l.quantity + "</span>" +
                '<button data-line-inc="' + (i + 1) + '" aria-label="Increase">+</button>' +
              "</div>" +
            "</div>" +
            '<div class="right">' +
              '<span class="p">' + money(l.final_line_price) + "</span>" +
              '<button class="rm" data-line-remove="' + (i + 1) + '">Remove</button>' +
            "</div>" +
          "</div>"
        );
      }).join("");
      if (foot) foot.style.display = "block";
      const tot = $("#cartTotal");
      if (tot) tot.textContent = money(cart.total_price);
    }

    const t = cart.total_price;
    const fill = $("#shipFill");
    if (fill) fill.style.width = Math.min(100, (t / FREE_SHIP) * 100) + "%";
    const msg = $("#shipMsg");
    if (msg) {
      msg.innerHTML = t >= FREE_SHIP
        ? "<b>Free shipping unlocked</b> — beautifully packed, on us"
        : "Add <b>" + money(FREE_SHIP - t) + "</b> more for free shipping";
    }
    updateCartRecs(cart);
  }

  /* ---------------- cart recommendations ---------------- */
  let cartRecsPid = null;
  function updateCartRecs(cart) {
    const box = document.getElementById("cartRecs");
    if (!box || !box.dataset.urlBase) return;
    if (!cart.items || !cart.items.length) {
      box.style.display = "none";
      box.innerHTML = "";
      cartRecsPid = null;
      return;
    }
    const pid = cart.items[0].product_id;
    if (pid === cartRecsPid && box.innerHTML.trim().length) return;
    cartRecsPid = pid;
    fetch(box.dataset.urlBase + "&product_id=" + pid)
      .then((r) => r.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        const inner = doc.querySelector("[data-cart-recs-inner]");
        if (inner && inner.innerHTML.trim().length) {
          box.innerHTML = inner.innerHTML;
          box.style.display = "block";
          const track = box.querySelector(".cart-recs-track");
          if (track) setupCarousel(track);
        } else {
          box.style.display = "none";
        }
      })
      .catch(() => { box.style.display = "none"; });
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  async function fetchCart() {
    try {
      const res = await fetch(window.BIRDIE.routes.cart + ".js", { headers: { Accept: "application/json" } });
      const cart = await res.json();
      renderCart(cart);
    } catch (e) { /* silent */ }
  }

  async function addToCart(variantId, qty) {
    const d = drawer();
    d && d.classList.add("loading");
    try {
      const res = await fetch(window.BIRDIE.routes.cartAdd + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] }),
      });
      if (!res.ok) {
        const err = await res.json();
        toast(err.description || "Could not add");
        return false;
      }
      await fetchCart();
      openCart();
      toast("Added to cart");
      return true;
    } catch (e) {
      toast("Something went wrong");
      return false;
    } finally {
      d && d.classList.remove("loading");
    }
  }

  async function changeLine(line, qty) {
    const d = drawer();
    d && d.classList.add("loading");
    try {
      const res = await fetch(window.BIRDIE.routes.cartChange + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: qty }),
      });
      const cart = await res.json();
      renderCart(cart);
    } catch (e) { /* silent */ }
    finally { d && d.classList.remove("loading"); }
  }

  window.birdieAddToCart = addToCart;

  // cart line controls (delegated)
  document.addEventListener("click", (e) => {
    const dec = e.target.closest("[data-line-dec]");
    const inc = e.target.closest("[data-line-inc]");
    const rem = e.target.closest("[data-line-remove]");
    if (dec) {
      const line = +dec.getAttribute("data-line-dec");
      const span = dec.parentElement.querySelector("span");
      changeLine(line, Math.max(0, (+span.textContent) - 1));
    } else if (inc) {
      const line = +inc.getAttribute("data-line-inc");
      const span = inc.parentElement.querySelector("span");
      changeLine(line, (+span.textContent) + 1);
    } else if (rem) {
      changeLine(+rem.getAttribute("data-line-remove"), 0);
    }
  });

  // quick add (from cards) — adds first available variant
  document.addEventListener("click", (e) => {
    const q = e.target.closest("[data-quick-add]");
    if (!q) return;
    e.preventDefault();
    e.stopPropagation();
    const vid = q.getAttribute("data-quick-add");
    if (!vid || vid === "0") { toast("Choose options on the product"); return; }
    addToCart(vid, 1);
  });

  /* ---------------- PDP ---------------- */
  function initPDP() {
  const form = $("#pdpForm");
  if (!form) return;

  const variants = window.BIRDIE_VARIANTS || [];
  const state = { size: null, color: null, qty: 1 }; // 👈 color add kiya
  const addBtn = $("#pAddBtn");
  const qtyEl = $("#pQty");
  const idInput = $("#pVariantId");

const colorIndex = parseInt($("#pColors")?.dataset.optionIndex || "1", 10);
const sizeIndex  = parseInt($("#pSizes")?.dataset.optionIndex || "2", 10);

function getOptionValue(variant, index) {
  return variant["option" + index];
}

function matchVariant() {
  if (!variants.length) return null;

  return variants.find((variant) => {

    let match = true;

    if (state.color) {
      match = match && getOptionValue(variant, colorIndex) === state.color;
    }

    if (state.size) {
      match = match && getOptionValue(variant, sizeIndex) === state.size;
    }

    return match;

  }) || null;
}

  function refresh() {
    const v = matchVariant();
    if (qtyEl) qtyEl.textContent = state.qty;
    if (v) {
      idInput.value = v.id;
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.querySelector("[data-add-label]").textContent = v.available ? "Add to cart" : "Sold out";
      }
    }
  }

  // size buttons
  $$("#pSizes button").forEach((b) => {
    b.addEventListener("click", () => {
      if (b.classList.contains("soldout")) return;
      $$("#pSizes button").forEach((x) => x.classList.remove("on"));
      b.classList.add("on");
      state.size = b.getAttribute("data-value");
      refresh();
    });
  });

  // color buttons
  $$("#pColors button").forEach((b) => {
    b.addEventListener("click", () => {
      if (b.classList.contains("soldout")) return;
      $$("#pColors button").forEach((x) => x.classList.remove("on"));
      b.classList.add("on");
      state.color = b.getAttribute("data-value"); // 👈 fix
      refresh();
    });
  });


    // qty
    $$("#pdpForm [data-qty]").forEach((b) => {
      b.addEventListener("click", () => {
        state.qty = Math.max(1, state.qty + (+b.getAttribute("data-qty")));
        refresh();
      });
    });

    // thumbs
    $$("#pThumbs button").forEach((b) => {
      b.addEventListener("click", () => {
        const src = b.getAttribute("data-full");
        const main = $("#pMain");
        if (main && src) main.src = src;
        $$("#pThumbs button").forEach((x) => x.classList.remove("on"));
        b.classList.add("on");
      });
    });

    function resolveVid() {
      if (variants.length > 1 && state.size == null) { toast("Select a size first"); return null; }
      return idInput.value || (variants[0] && variants[0].id) || null;
    }

    form.addEventListener("submit", (e) => {
      e.preventDefault();
      const vid = resolveVid();
      if (vid) addToCart(vid, state.qty);
    });

    refresh();
  }

  /* ---------------- predictive search ---------------- */
  function initSearch() {
    const input = $("#searchInput");
    if (!input) return;
    const grid = $("#searchGrid");
    const noRes = $("#noResults");
    const countEl = $("#searchCount");
    let timer;

    async function run() {
      const q = input.value.trim();
      if (!q) {
        if (grid) grid.innerHTML = "";
        if (noRes) noRes.style.display = "none";
        if (countEl) countEl.textContent = "";
        return;
      }
      try {
        const url = window.BIRDIE.routes.predictiveSearch +
          "?q=" + encodeURIComponent(q) +
          "&resources[type]=product&resources[limit]=12&section_id=predictive-search";
        const res = await fetch(url);
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, "text/html");
        const results = doc.querySelector("#predictive-search-results");
        const items = results ? results.innerHTML.trim() : "";
        if (grid) grid.innerHTML = items;
        const n = results ? results.querySelectorAll(".item").length : 0;
        if (noRes) noRes.style.display = n ? "none" : "block";
        if (countEl) countEl.textContent = String(n).padStart(2, "0") + " result" + (n === 1 ? "" : "s");
      } catch (e) { /* silent */ }
    }

    input.addEventListener("input", () => { clearTimeout(timer); timer = setTimeout(run, 220); });

    $$("[data-quick-search]").forEach((b) => {
      b.addEventListener("click", () => {
        input.value = b.getAttribute("data-quick-search");
        run();
        input.focus();
      });
    });
  }

  /* ---------------- newsletter (footer) ---------------- */
  function initNewsletter() {
    $$(".footer-newsletter").forEach((form) => {
      form.addEventListener("submit", () => {
        // let Shopify handle the POST; show a friendly note
        const ok = form.querySelector("[data-newsletter-ok]");
        if (ok) ok.style.display = "block";
      });
    });
  }

  /* ---------------- hero carousel ---------------- */
  function initHero() {
    const root = $("[data-hero]");
    if (!root) return;
    if (root.dataset.heroReady === "1") return;
    root.dataset.heroReady = "1";
    const track = $(".hero-track", root);
    const slides = $$(".hero-slide", root);
    if (!track || slides.length < 2) return;

    const dots = $$("[data-hero-dot]", root);
    let index = 0;
    let timer = null;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const autoplay = root.getAttribute("data-autoplay") === "true" && !reduce;
    const speed = Math.max(3000, +root.getAttribute("data-speed") || 6000);

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.style.transform = "translateX(-" + index * 100 + "%)";
      dots.forEach((d, di) => d.classList.toggle("on", di === index));
    }
    function next() { go(index + 1); }
    function prev() { go(index - 1); }
    function start() { if (autoplay) { stop(); timer = setInterval(next, speed); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    const nextBtn = $("[data-hero-next]", root);
    const prevBtn = $("[data-hero-prev]", root);
    if (nextBtn) nextBtn.addEventListener("click", () => { next(); start(); });
    if (prevBtn) prevBtn.addEventListener("click", () => { prev(); start(); });
    dots.forEach((d) => d.addEventListener("click", () => { go(+d.getAttribute("data-hero-dot")); start(); }));

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);

    // basic touch swipe
    let x0 = null;
    root.addEventListener("touchstart", (e) => { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener("touchend", (e) => {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
      x0 = null;
      start();
    });

    go(0);
    start();
  }

  /* ---------------- reel (video carousel) ---------------- */
  function initReel() {
    const root = $("[data-reel]");
    if (!root) return;
    if (root.dataset.reelReady === "1") return;
    root.dataset.reelReady = "1";
    const vp = $("[data-reel-viewport]", root);
    const track = $(".reel-track", root);
    const cards = $$(".reel-card", root);
    if (!vp || !track || !cards.length) return;

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // --- video autoplay (only while in view) ---
    const autoVideos = root.getAttribute("data-autoplay-videos") === "true" && !reduce;
    const videos = $$("video", root);
    if (autoVideos && "IntersectionObserver" in window) {
      const vio = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          const v = e.target;
          if (e.isIntersecting) { v.play().catch(() => {}); }
          else { v.pause(); }
        });
      }, { threshold: 0.5 });
      videos.forEach((v) => { v.muted = true; vio.observe(v); });
    } else if (!autoVideos) {
      videos.forEach((v) => v.setAttribute("controls", ""));
    }

    // --- mute toggles ---
    $$("[data-reel-mute]", root).forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const card = btn.closest(".reel-card");
        const v = card && card.querySelector("video");
        if (!v) return;
        v.muted = !v.muted;
        btn.setAttribute("aria-pressed", String(!v.muted));
        if (!v.muted) v.play().catch(() => {});
      });
    });

    // --- carousel auto-scroll ---
    const autoScroll = root.getAttribute("data-autoplay") === "true" && !reduce;
    const speed = Math.max(2000, +root.getAttribute("data-speed") || 4000);
    let timer = null;
    function stepPx() {
      const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16) || 16;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function advance() {
      const max = vp.scrollWidth - vp.clientWidth - 4;
      if (vp.scrollLeft >= max) vp.scrollTo({ left: 0, behavior: "smooth" });
      else vp.scrollBy({ left: stepPx(), behavior: "smooth" });
    }
    function start() { if (autoScroll && cards.length > 1) { stop(); timer = setInterval(advance, speed); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    const nextBtn = $("[data-reel-next]", root);
    const prevBtn = $("[data-reel-prev]", root);
    if (nextBtn) nextBtn.addEventListener("click", () => { vp.scrollBy({ left: stepPx(), behavior: "smooth" }); start(); });
    if (prevBtn) prevBtn.addEventListener("click", () => { vp.scrollBy({ left: -stepPx(), behavior: "smooth" }); start(); });

    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    vp.addEventListener("touchstart", stop, { passive: true });

    start();
  }

  /* ---------------- generic carousels (auto-scroll when horizontally scrollable) ---------------- */
  function setupCarousel(el) {
    if (!el || el.dataset.carouselReady === "1") return;
    el.dataset.carouselReady = "1";
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const autoplay = el.getAttribute("data-autoplay") === "true" && !reduce;
    const speed = Math.max(2000, +el.getAttribute("data-speed") || 4000);
    let timer = null;
    function scrollable() { return el.scrollWidth - el.clientWidth > 8; }
    function stepPx() {
      const first = el.querySelector(":scope > *");
      const style = getComputedStyle(el);
      const gap = parseFloat(style.columnGap || style.gap || 0) || 0;
      return first ? first.getBoundingClientRect().width + gap : el.clientWidth * 0.8;
    }
    function advance() {
      if (!scrollable()) return;
      const max = el.scrollWidth - el.clientWidth - 4;
      if (el.scrollLeft >= max) el.scrollTo({ left: 0, behavior: "smooth" });
      else el.scrollBy({ left: stepPx(), behavior: "smooth" });
    }
    function start() { if (autoplay && scrollable()) { stop(); timer = setInterval(advance, speed); } }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    el.addEventListener("mouseenter", stop);
    el.addEventListener("mouseleave", start);
    el.addEventListener("touchstart", stop, { passive: true });
    let rz;
    window.addEventListener("resize", () => { clearTimeout(rz); rz = setTimeout(() => { stop(); start(); }, 250); });
    start();
  }
  function initCarousels(root) {
    (root || document).querySelectorAll("[data-carousel]").forEach(setupCarousel);
  }

  /* ---------------- product recommendations (PDP "Complete the look") ---------------- */
  function initProductRecs() {
    const el = $("[data-product-recommendations]");
    if (!el || !el.dataset.url) return;
    fetch(el.dataset.url)
      .then((r) => r.text())
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        const inner = doc.querySelector("[data-product-recommendations]");
        if (inner && inner.innerHTML.trim().length) {
          el.innerHTML = inner.innerHTML;
          initCarousels(el);
        }
      })
      .catch(() => {});
  }

  /* ---------------- reveal ---------------- */
  function initReveal() {
    const els = $$(".rv");
    if (!els.length) return;
    // In the theme editor, reveal everything immediately so nothing is invisible.
    if ((window.Shopify && window.Shopify.designMode) || !("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("in"));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
    }, { threshold: 0.1 });
    els.forEach((el) => io.observe(el));
  }

  /* ---------------- init ---------------- */
  function init() {
    initPDP();
    initSearch();
    initNewsletter();
    initHero();
    initReel();
    initCarousels();
    initProductRecs();
    initReveal();
    fetchCart();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  /* ---------------- Shopify theme editor ---------------- */
  // When a section is re-rendered or selected in the editor, its freshly
  // injected HTML isn't observed by the reveal IO, so reveal it immediately
  // and re-init any carousels/widgets inside it.
  function refreshSection(sec) {
    if (!sec || !sec.querySelectorAll) return;
    sec.querySelectorAll(".rv").forEach((el) => el.classList.add("in"));
    initCarousels(sec);
    if (sec.querySelector("[data-hero]")) initHero();
    if (sec.querySelector("[data-reel]")) initReel();
    if (sec.querySelector("[data-product-recommendations]")) initProductRecs();
    if (sec.querySelector("#navDrawer") || sec.querySelector(".site-header")) fetchCart();
  }
  document.addEventListener("shopify:section:load", (e) => refreshSection(e.target));
  document.addEventListener("shopify:section:select", (e) => refreshSection(e.target));
  document.addEventListener("shopify:block:select", (e) => {
    const sec = e.target && e.target.closest ? e.target.closest(".shopify-section") : null;
    if (sec) sec.querySelectorAll(".rv").forEach((el) => el.classList.add("in"));
  });
})();
